export const arrayEquals = (a: string[] | number[], b: string[] | number[]) => {
  return Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    // @ts-ignore
    a.every((val: string | number, index: number) => val === b[index]);
}